import { render, staticRenderFns } from "./examDialog.vue?vue&type=template&id=11a58486&scoped=true"
import script from "./examDialog.vue?vue&type=script&lang=js"
export * from "./examDialog.vue?vue&type=script&lang=js"
import style0 from "./examDialog.vue?vue&type=style&index=0&id=11a58486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a58486",
  null
  
)

export default component.exports